import { Interval } from 'luxon';

import merchantGatewayApi from 'apis/merchant-gateway/api';
import { EntityType } from 'common/types';

import { RejectedPurchasesSortable, RejectedPurchasesInsight } from './types';
import { SortOrder } from '../types';
import { getBaseUrl, getDateRangeForApiCall } from '../utils';

export const getRejectedPurchasesInsightForEntity = ({
  entityType,
  entityId,
  interval,
  limit,
  cursor,
  sortBy,
  sortOrder,
}: {
  entityType: EntityType;
  entityId: string;
  interval: Interval;
  /** default value is 1 to 100, max value 100 */
  limit?: number;
  cursor?: string;
  /** default value is 'TIME_RECEIVED' */
  sortBy?: RejectedPurchasesSortable;
  /** default value is 'DESC' */
  sortOrder?: SortOrder;
}) => {
  return merchantGatewayApi
    .get<RejectedPurchasesInsight>(`${getBaseUrl(entityType, entityId)}/rejected-purchases`, {
      params: {
        ...getDateRangeForApiCall(interval),
        limit,
        cursor,
        sort_by: sortBy,
        sort_order: sortOrder,
      },
    })
    .then(response => response.data);
};
